module.exports = __webpack_public_path__ + "lp/img/arrow_left_white.7d422ad9.svg";